module.exports = __webpack_public_path__ + "static/media/oops.0cffbb54.jpg";